<template>
	<div class="modalInputs">
		<div class="modal-container modal-inputs l">
			<div class="modal-header">
				{{ title }}
			</div>
			<div
				class="modal-body"
				:style="$grid('1')"
			>
				<div
					v-if="Array.isArray(info)"
					class="modal-body-info"
					:style="$grid('1')"
				>
					<span
						v-for="(i, index) in info"
						:key="index"
						>{{ i }}</span
					>
				</div>
				<div
					v-else
					class="modal-body-info"
				>
					{{ info }}
				</div>

				<InputTextbox
					:label="input.label"
					v-model:saturn="input.value"
					:disabled="input.disabled"
					:placeholder="input.placeholder"
				/>

				<div
					v-if="additionalInfo"
					class="modal-body-info modal-body-info-important"
				>
					{{ additionalInfo }}
				</div>
			</div>
			<div class="modal-footer">
				<button
					v-if="cancelText"
					:class="cancelTextClass ? cancelTextClass : 'button-unwind'"
					@click="cancel()"
				>
					{{ cancelText }}
				</button>
				<button
					v-if="acceptText"
					:class="acceptTextClass ? acceptTextClass : 'button-save'"
					@click="close()"
				>
					{{ acceptText }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import $modal from '@core/services/modal';
	import InputTextbox from '@core/components/InputTextbox.vue';

	export default {
		name: 'modalInputs',
		props: ['modal'],
		data() {
			return {
				title: 'Information',
				info: null,
				cancelText: null,
				cancelTextClass: null,
				acceptText: null,
				acceptTextClass: null,
				additionalData: null,
				additionalInfo: null,
				value: null,
				input: {},
			};
		},
		computed: {},
		created() {
			this.info = this.modal.passedData.info;
			this.acceptText = this.modal.passedData.acceptText;
			this.acceptTextClass = this.modal.passedData.acceptTextClass;
			this.cancelText = this.modal.passedData.cancelText;
			this.cancelTextClass = this.modal.passedData.cancelTextClass;
			this.additionalData = this.modal.passedData.additionalData;
			this.additionalInfo = this.modal.passedData.additionalInfo;
			this.input = this.modal.passedData.input ?? {};

			if (this.modal.passedData.title) this.title = this.modal.passedData.title;
		},
		methods: {
			close() {
				$modal.close(this.input.value);
			},
			cancel() {
				if (typeof this.modal.passedData.cancelFunction == 'function') {
					this.modal.passedData.cancelFunction();
				}
				$modal.cancel();
			},
		},
		components: {
			InputTextbox,
		},
	};
</script>
<style>
	.modalInputs {
		margin: auto;
	}

	.modalInputs .modal-body {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.modalInputs .modal-body-info {
		white-space: pre-wrap;
		margin: 10px 0;
	}

	.modalInputs .modal-body-info-important {
		font-weight: bold;
	}

	.modalInputs .modal-container {
		width: auto;
		max-width: 815px;
	}

	.modalInputs .modal-container .modal-footer > button {
		width: unset !important;
		padding: 10px;
	}
</style>
